import * as React from 'react';
import {Image as VWImage} from '@volkswagen-onehub/components-core';
import {ImageProps} from '@volkswagen-onehub/whitelabel-e-mobility-commons';

export function Image(props: ImageProps): JSX.Element {
  return <VWImage {...props} data-testid={props.testId} />;
}
